// Enums from the configuration file
export enum FormFieldEnums {
  Label = "label",
  Email = "email",
  Number = "number",
  Phone = "phone",
  Password = "password",
  Text = "text",
  Button = "button",
  Checkbox = "checkbox",
  CountriesSelect = "countries-select",
  Select = "select",
  Group = "group",
  Date = "date",
  Toggle = "toggle",
  ToggleMulti = "ToggleMulti",
  Popup = "popup",
  Switch = "switch",
  Textarea = "textarea",
  ToolTipButton = "tooltip-button",
}

// Enums to use in the componets
export enum FormComponentEnums {
  Submit = "submit",
}
